import { AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ResourceManagerService } from '@barthauer/abc/core/resources';
import { ResourceSet } from 'libs/abc/core/resources/src/lib/resource-set';

@Component({
    selector: 'abc-graphics-path-selector',
    templateUrl: './path-selector.component.html',
    styleUrls: ['./path-selector.component.scss'],
    standalone: false
})
export class PathSelectorComponent implements AfterViewInit, OnInit {
  @ViewChild('selectorContainer', { static: false }) selectorContainer: ElementRef;
  @Output() pathSelectionClosed = new EventEmitter();
  @Output() cancelPathSelection = new EventEmitter();

  public resAsync: Promise<ResourceSet>
  public res = ResourceSet.Empty;

  constructor(private resourceService: ResourceManagerService) {
    this.resAsync = this.resourceService.getResourceSet('abc-graphics-adapters-open-layers');
  }

  async ngOnInit() {
    this.res = await this.resAsync;
  }

  ngAfterViewInit() {
    this.setVisible(false);
  }

  setVisible(visible: boolean): void {
    if (this.selectorContainer && this.selectorContainer.nativeElement)
      this.selectorContainer.nativeElement.style.display = visible ? 'block' : 'none';
  }

  close() {
    this.setVisible(false);
    this.pathSelectionClosed.emit();
  }
  cancel() {
    this.setVisible(false);
    this.cancelPathSelection.emit();
  }
}
